export default __webpack_public_path__ + "static/media/banner03.b44fbc1f.png";